import React, { useState } from 'react';
import { Button, ButtonGroup } from 'reactstrap';

const RadioButtonGroup = ({ buttons, onSelectionHandler, initialValue, emptyValue = null }) => {
    const [selectedValue, setSelectedValue] = useState(initialValue);

    const handleSelectionChange = (value) => {
        let newValue = emptyValue !== null && value === selectedValue ? emptyValue : value;
        setSelectedValue(newValue);
        onSelectionHandler(newValue);
    };

    return (
            <ButtonGroup>
                {buttons.map((button) => (
                                        <Button
                                            key={button.value}
                                            className="text-nowrap"
                                            color="secondary"
                                            outline
                                            onClick={() => handleSelectionChange(button.value)}
                                            active={selectedValue === button.value}
                                            >
                                            {button.title}
                                        </Button>
                                        ))}
            </ButtonGroup>
            );
};

export default RadioButtonGroup;
